<div class="tw-pb-10 tw-mt-8" *ngIf="pastApplications.length == 0">
    {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
</div>
<div
    *ngIf="pastApplications.length > 0"
    class="tw-bg-white tw-shadow-sm tw-rounded-[24px] tw-border tw-border-[#6D7A873D]"
>
    <div class="tw-overflow-x-auto">
        <table class="tw-min-w-full tw-divide-y tw-divide-[#E5E7EB]">
            <thead>
                <tr>
                    <th
                        class="tw-text-left tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                    >
                        {{ "COMMON.PRODUCT" | translate }}
                    </th>
                    <th
                        class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                    >
                        {{ "COMMON.FINANCING_AMOUNT" | translate }}
                    </th>
                    <th
                        class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                    >
                        {{ "COMMON.TENURE" | translate }}
                    </th>
                    <th
                        class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080] !tw-text-center"
                    >
                        {{ "COMMON.REFERRAL_DATE" | translate }}
                    </th>
                    <th
                        class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                    >
                        {{ "COMMON.STATUS" | translate }}
                    </th>
                    <th
                        class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080] !tw-text-center"
                    ></th>
                </tr>
            </thead>
            <tbody
                class="tw-text-sm tw-text-[#000000] tw-divide-y tw-divide-[#E5E7EB]"
            >
                <tr *ngFor="let item of pastApplications">
                    <td class="tw-py-4 tw-px-4 tw-w-[280px]">
                        <p
                            class="tw-text-[12px] tw-font-semibold tw-text-[#00000080] tw-mb-1"
                        >
                            {{ "COMMON.RECENT_APPID" | translate }}:
                            {{ item.cCaseAppNo }}
                        </p>
                        <p class="tw-text-[16px] tw-font-semibold">
                            {{ item.productName }}
                        </p>
                    </td>
                    <td
                        class="tw-py-4 tw-px-3 tw-text-[14px] tw-w-[170px] tw-font-normal"
                    >
                        {{
                            item.cCaseFinamt == null
                                ? "N/A"
                                : (item.cCaseFinamt
                                  | currency : "RM" : true : "1.0-0")
                        }}
                    </td>
                    <td class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal">
                        N/A
                        <!-- ask -->
                    </td>
                    <td
                        class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-text-center"
                    >
                        {{ formatDate(item.createdDateTime) }}<br />
                        {{ convertToTimeFormat(item.createdDateTime) }}
                    </td>
                    <td
                        class="tw-py-4 tw-px-4 tw-text-[14px] tw-w-[190px] tw-font-semibold"
                    >
                        {{ item.cCaseStatus | translate }}
                    </td>
                    <td class="tw-py-4 tw-px-4 tw-w-[160px]">
                        <button
                            class="tw-border tw-border-[#003A70] tw-text-[#003A70] tw-text-xs tw-font-semibold tw-rounded-[20px] tw-w-[120px] tw-h-[34px]"
                            (click)="viewAppDetails(item)"
                        >
                            {{ "COMMON.VIEW_DETAILS" | translate }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
